import { container } from "inversify-props";
import {
  AbpApplicationConfigurationApi,
  FeaturesApi,
  PermissionsApi,
  RoleApi,
  TenantApi,
  UserApi,
  DataImportApi,
  StyleApi,
  CustomerApi,
  ReportApi,
  UserAdminSettingApi,
  ShadeApi,
  StyleOperationStitchNBLCApi,
  ProductCategoryApi,
  ProductTypeApi,
  StitchTypeApi,
  StitchNBLCTypesApi,
  BrandApi,
  TicketTexApi,
  PackageSizeApi,
  StyleOperationApi,
  PreLoginApi,
  CustomSettingsApi,
  ColorGroupApi
} from "@/api";

/**
 * Define Dependency Injection for:
 *  - Application specific services
 *  - API clients
 */
export function appContainerBuilder(): void {
  // Core APIs - Do not modify
  container.addTransient(AbpApplicationConfigurationApi, "AbpApplicationConfigurationApi");
  container.addTransient(UserApi, "UserApi");
  container.addTransient(RoleApi, "RoleApi");
  container.addTransient(TenantApi, "TenantApi");
  container.addTransient(FeaturesApi, "FeaturesApi");
  container.addTransient(PermissionsApi, "PermissionsApi");
  container.addTransient(DataImportApi, "DataImportApi");
  container.addTransient(StyleApi, "StyleApi");
  container.addTransient(CustomerApi, "CustomerApi");
  container.addTransient(ReportApi, "ReportApi");
  container.addTransient(ShadeApi, "ShadeApi");
  container.addTransient(UserAdminSettingApi, "UserAdminSettingApi");
  container.addTransient(StyleOperationStitchNBLCApi, "StyleOperationStitchNBLCApi");
  container.addTransient(ProductCategoryApi, "ProductCategoryApi");
  container.addTransient(ProductTypeApi, "ProductTypeApi");
  container.addTransient(StitchTypeApi, "StitchTypeApi");
  container.addTransient(StitchNBLCTypesApi, "StitchNBLCTypesApi");
  container.addTransient(BrandApi, "BrandApi");
  container.addTransient(TicketTexApi, "TicketTexApi");
  container.addTransient(PackageSizeApi, "PackageSizeApi");
  container.addTransient(StyleOperationApi, "StyleOperationApi");
  container.addTransient(PreLoginApi, "PreLoginApi");
  container.addTransient(CustomSettingsApi, "CustomSettingsApi");
  container.addTransient(ColorGroupApi, "ColorGroupApi");
  // Other APIs
}
